import { IconAtom } from "../atoms/iconAtom";
import { HorizontalLayout, VerticalLayout } from "./layout";

export function ProjectStepCardComp({ onClick, title, selected, index, iconName, className, imgUrl }) {
  return (
    <VerticalLayout
      onClick={onClick}
      className={`project-step-comp standard-rounded standard-border ${selected ? "selected" : ""} ${className || ""}`}
      style={{
        cursor: "pointer",
        backgroundColor: selected ? "var(--primary-50)" : "var(--white)",
        padding: "0.75rem",
        gap: "0.75rem",
        transition: "0.2s ease-in-out",
        borderRadius: "1rem",
        width: "auto",
        height: "auto", 
      }}
    >
      {imgUrl && (
        <div style={{ width: "100%", height: "120px", overflow: "hidden", borderRadius: "0.5rem" }}>
          <img
            src={imgUrl}
            alt={title}
            style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "0.5rem" }}
          />
        </div>
      )}

      <HorizontalLayout style={{ alignItems: "center", gap: "0.5rem", justifyContent: "space-between" }}>
        <HorizontalLayout style={{ alignItems: "flex-start", gap: "0.5rem" }}>
          <p
            className="standard-text"
            style={{ color: selected ? "var(--primary-700)" : "var(--standard-text-color)", fontWeight: 500 }}
          >
            {title}
          </p>
        </HorizontalLayout>

        {selected && <IconAtom icon2="check" color="primary-600" />}
      </HorizontalLayout>
    </VerticalLayout>
  );
}